<app-screen-shell
  [contentClass]="'container player-profile-page public-player-profile-page'"
  [variant]="isAuthenticatedProfileView() ? 'app' : 'public'"
  [title]="headerTitle()"
  [loading]="loadingVisible"
  loadingTitleKey="publicProfile.loading"
  [hideContentWhileLoading]="true"
  (back)="goBack()">
  @if (!loading && unavailable) {
    <section class="public-player-profile-state">
      <i [class]="'player.unavailable' | nogoshIcon" aria-hidden="true"></i>
      <h1>{{ 'publicProfile.unavailableTitle' | translate }}</h1>
      <p>{{ 'publicProfile.unavailableText' | translate }}</p>
    </section>
  }

  @if (!loading && profile) {
    <section class="card profile-content-width player-detail-content-width player-detail-card public-player-profile-card">
      <div class="player-detail-card-body">
        <div class="player-detail-summary">
          <div class="player-detail-card-actions">
            <button type="button" class="player-detail-share-button" [title]="'players.shareProfile' | translate" [attr.aria-label]="'players.shareProfile' | translate" (click)="shareProfile()">
              <i [class]="'common.share' | nogoshIcon" aria-hidden="true"></i>
            </button>
          </div>
          <div class="player-detail-heading">
            <button type="button" class="player-detail-avatar-shell player-detail-shortcut" [disabled]="!profile.avatar && !isOwnProfile()"
              [attr.aria-label]="'players.avatarTitle' | translate" (click)="openAvatar()">
              <img [src]="profile.avatar ? profile.avatar : 'assets/images/user1.jpg'"
                onerror="this.src='assets/images/user1.jpg'" class="player-detail-avatar rounded-circle border"
                [alt]="'accessibility.userProfileImage' | translate">
            </button>
            <div class="player-detail-heading-copy">
              @if (isOwnProfile()) {
                <button type="button" class="player-detail-title-shortcut player-detail-shortcut is-enabled" (click)="editOwnName()"><span class="player-detail-nickname mb-0 text-truncate">{{profile.nickName || profile.name}}</span></button>
              } @else { <h1 class="player-detail-nickname mb-0 text-truncate">{{profile.nickName || profile.name}}</h1> }
              @if (profile.name && profile.name !== profile.nickName) {
                <p class="player-detail-name mb-0 text-truncate">{{profile.name}}</p>
              }
              <div class="player-detail-context">
                @if (displayCity()) {
                  <span>{{ displayCity() }}</span>
                }
                @if (joinedAt()) {
                  <span class="player-detail-meta-pill">{{ 'players.joined' | translate }} {{ joinedAt() | date:'MMM yyyy' }}</span>
                }
              </div>
            </div>
          </div>

          <div class="player-detail-stats-layout">
            <div class="player-detail-rating-column">
              <div class="player-detail-metric is-rating" [title]="'players.offence' | translate">
                <span class="player-detail-metric-label">{{ 'players.offence' | translate }}</span>
                <strong><i [class]="'player.rating' | nogoshIcon" aria-hidden="true"></i>{{ profile.ratingAverageOffence || '–' }}</strong>
              </div>
              <div class="player-detail-metric is-rating" [title]="'players.defence' | translate">
                <span class="player-detail-metric-label">{{ 'players.defence' | translate }}</span>
                <strong><i [class]="'player.rating' | nogoshIcon" aria-hidden="true"></i>{{ profile.ratingAverageDefence || '–' }}</strong>
              </div>
            </div>
            <div class="player-detail-performance-column">
              <div class="player-detail-metric player-detail-record-metric is-primary">
                <div class="player-detail-record-value">
                  <div class="player-detail-played-count">
                    <span>{{ 'stats.played' | translate }}</span>
                    <strong>{{ profileStatValue(profile.stats?.playedGames) }}</strong>
                  </div>
                  <div class="player-detail-record-breakdown">
                    <span><strong>{{ profileStatValue(profile.stats?.playerWins) }}</strong>W</span>
                    <span><strong>{{ profileStatValue(profile.stats?.playerDraws) }}</strong>D</span>
                    <span><strong>{{ profileStatValue(profile.stats?.playerLoses) }}</strong>L</span>
                  </div>
                </div>
              </div>
              <div class="player-detail-metric player-detail-goal-metric" [title]="'players.teamGoalDeltaHint' | translate">
                <div class="player-detail-goal-value">
                  <div class="player-detail-goal-delta">
                    <span>{{ 'players.goals' | translate }} Δ</span>
                    <strong>{{ teamGoalScore() }}</strong>
                  </div>
                  <div class="player-detail-goal-breakdown">
                    <span [title]="'players.goalsForHint' | translate"><strong>{{ profileStatValue(profile.stats?.playerScored) }}</strong>GF</span>
                    <span [title]="'players.goalsAgainstHint' | translate"><strong>{{ profileStatValue(profile.stats?.playerConceded) }}</strong>GA</span>
                  </div>
                </div>
              </div>
              <div class="player-detail-metric player-detail-teams-metric">
                <span class="player-detail-metric-label">{{ 'players.teamsCount' | translate }}</span>
                <strong>{{ profileStatValue(profile.stats?.teamsCount) }}</strong>
              </div>
            </div>
          </div>

          @if (hasProfileActions()) {
            <div class="player-detail-actions public-player-profile-actions">
              <div class="player-detail-actions-group player-detail-contact-actions-bottom">
                @if (canChat()) {
                  <button type="button" class="player-detail-contact-action is-primary" [disabled]="chatLoading" (click)="openChat()" [title]="'players.chat' | translate" [attr.aria-label]="'players.chat' | translate">
                    <i [class]="'chat.chat' | nogoshIcon" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'players.chat' | translate }}</span>
                  </button>
                }
                @if (profile.phoneNumber) {
                  <a class="player-detail-contact-action" [href]="'tel:' + profile.phoneNumber" [title]="'players.call' | translate" [attr.aria-label]="'players.call' | translate">
                    <i [class]="'player.phone' | nogoshIcon" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'players.call' | translate }}</span>
                  </a>
                }
                @if (profile.email) {
                  <a class="player-detail-contact-action" [href]="'mailto:' + profile.email" [title]="'common.email' | translate" [attr.aria-label]="'common.email' | translate">
                    <i [class]="'player.email' | nogoshIcon" aria-hidden="true"></i>
                    <span class="sr-only">{{ 'common.email' | translate }}</span>
                  </a>
                }
                @if (canModerate()) {
                  <button type="button" class="btn btn-outline-secondary" (click)="showBlockDialog = true">
                    {{ 'safety.blockUser' | translate }}
                  </button>
                  <button type="button" class="btn btn-outline-danger" (click)="showReportDialog = true">
                    {{ 'safety.reportAndBlock' | translate }}
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </section>
  }

  <app-dialog [(visible)]="showBlockDialog" [closable]="false" class="app-dialog--confirm">
    <div class="modal-header"><h4>{{ 'safety.blockUser' | translate }}</h4></div>
    <div class="modal-body">{{ 'safety.blockDescription' | translate }}</div>
    @if (errorMsg) { <div class="alert alert-danger">{{ errorMsg }}</div> }
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="showBlockDialog = false">{{ 'common.cancel' | translate }}</button>
      <button type="button" class="btn btn-danger" [disabled]="moderationLoading" (click)="blockPlayer()">{{ 'safety.block' | translate }}</button>
    </div>
  </app-dialog>

  <app-dialog [(visible)]="showReportDialog" [closable]="false" class="app-dialog--confirm">
    <div class="modal-header"><h4>{{ 'safety.reportAndBlock' | translate }}</h4></div>
    <div class="modal-body">
      <label for="reportReason">{{ 'safety.reason' | translate }}</label>
      <select id="reportReason" class="form-control" [(ngModel)]="reportReason">
        <option value="HARASSMENT">{{ 'safety.reasons.harassment' | translate }}</option>
        <option value="SPAM">{{ 'safety.reasons.spam' | translate }}</option>
        <option value="IMPERSONATION">{{ 'safety.reasons.impersonation' | translate }}</option>
        <option value="INAPPROPRIATE_CONTENT">{{ 'safety.reasons.inappropriateContent' | translate }}</option>
        <option value="OTHER">{{ 'safety.reasons.other' | translate }}</option>
      </select>
      <label for="reportDetails">{{ 'safety.detailsOptional' | translate }}</label>
      <textarea id="reportDetails" class="form-control" maxlength="1000" [(ngModel)]="reportDetails"></textarea>
      <p>{{ 'safety.reportDescription' | translate }}</p>
      @if (errorMsg) { <div class="alert alert-danger">{{ errorMsg }}</div> }
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="showReportDialog = false">{{ 'common.cancel' | translate }}</button>
      <button type="button" class="btn btn-danger" [disabled]="moderationLoading" (click)="reportPlayer()">{{ 'safety.reportAndBlock' | translate }}</button>
    </div>
  </app-dialog>
  @if (profile) {
    <app-dialog [(visible)]="showAvatarPreview">
      <div class="modal-header"><h2 class="h5 mb-0">{{ profile.nickName || profile.name }}</h2></div>
      <div class="modal-body"><img [src]="profile.avatar" [alt]="'accessibility.userProfileImage' | translate" class="profile-avatar-preview"></div>
      <div class="modal-footer"><button type="button" class="btn btn-secondary" (click)="showAvatarPreview = false">{{ 'common.close' | translate }}</button></div>
    </app-dialog>
  }
</app-screen-shell>
